import { render, staticRenderFns } from "./UploadFileChecklist.vue?vue&type=template&id=39a21081&scoped=true&"
import script from "./UploadFileChecklist.vue?vue&type=script&lang=ts&"
export * from "./UploadFileChecklist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a21081",
  null
  
)

export default component.exports